import { isAccountFeatureEnabled } from "owa-feature-flags";
import { getStore as getReadingPaneStore } from "owa-mail-reading-pane-store/lib/store/Store";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import getGlobalSettingsAccountMailboxInfo from "owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo";

export function showRefreshToEnableScreenCaptureInfoBar(): boolean {
    if (!getReadingPaneStore().blockScreenAPIExecuted) {
        return false;
    }
    
    if (getUserConfiguration().UserOptions?.BlockSCDoNotAskAgain) {
        return false;
    }
    
    if (!isAccountFeatureEnabled("cmp-infobar-block-screencapture", getGlobalSettingsAccountMailboxInfo())) {
        return false;
    }
    
    return true;
}
